
const INITIAL_COUNTER = 10_000;
const MS_IN_DAY       = 86_400_000;
const MIN_COUNTER     = 4;

const EASING_FUNCTIONS = {
  easeFastEnds:   p => 1 - (p + Math.sin(2 * Math.PI * p) / (2 * Math.PI)),
  sCurve:         p => 1 - (3*p*p - 2*p*p*p),
  linear:         p => 1 - p,
  quadraticOut:   p => 1 - p*p,
  exponentialOut: p => Math.pow(2, -10*p),
  power16: p => Math.pow(1 - p, 1.6),
  power18: p => Math.pow(1 - p, 1.8),
};

function msSinceUtcMidnight(now = Date.now()) {
  const d = new Date(now);
  d.setUTCHours(0, 0, 0, 0);
  return now - d.getTime();
}


function toUtcMidnightMs(dateLike) {
  const d = new Date(dateLike);
  d.setUTCHours(0, 0, 0, 0);
  return d.getTime();
}


function getCurrentCounter(
  now        = Date.now(),
  startDate  = null,
  endDate    = null,
  easingName = "power18",
  number     = INITIAL_COUNTER
) {
  if (!startDate && !endDate) {
    const progress = Math.min(1, msSinceUtcMidnight(now) / MS_IN_DAY);
    if (progress >= 1) return 0;
    const easing = EASING_FUNCTIONS[easingName] ?? EASING_FUNCTIONS.sCurve;
    return Math.max(0, Math.floor(number * easing(progress)));
  }

  const startMs = startDate
    ? new Date(startDate).getTime()
    : toUtcMidnightMs(now);

  const endMs = endDate
    ? new Date(endDate).getTime()
    : startMs + MS_IN_DAY;

  if (now < startMs) return number;
  if (now >= endMs)  return 0;

  const duration  = endMs - startMs;
  const progress  = (now - startMs) / duration;
  const easing    = EASING_FUNCTIONS[easingName] ?? EASING_FUNCTIONS.sCurve;
  const remaining = easing(Math.min(1, progress));

  return Math.max(0, Math.floor(number * remaining));
}

function itemsLeftCounter(
  id,
  {
    startDate  = null,
    endDate    = null,
    easingName = "power18",
    number     = INITIAL_COUNTER,
    min        = MIN_COUNTER           
  } = {}
) {
  const $out = document.getElementById(id);
  if (!$out) return;

  (function tick () {
    const raw   = getCurrentCounter(Date.now(), startDate, endDate, easingName, number);
    const value = Math.max(min, raw);

    $out.textContent = value.toLocaleString("en-US");

    if (raw > min) setTimeout(tick, 1_000); 
  })();
}